var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-tab-btn-wrap"},_vm._l((_vm.data),function(item,index){return _c('button',{key:index,staticClass:"menu-tab-btn__item",class:_vm.value === item.value? 'menu-tab-btn__item--active': '',on:{"click":function($event){return _vm.changeMethod(item)}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }